<script setup lang="ts">
import type { CmsElementSubCategoryBox } from "~/composables/useCustom";
import {getSanitizeUrl} from "~/components/utilities";

const props = defineProps<{
  content: CmsElementSubCategoryBox;
  class: any;
  style: any;
}>();

const config = props.content?.config ?? {};
const heading = config.heading;
const categories = config.categories;
const more = config.more;

const hidden = ref(true);
const buttonText = ref(more?.value?.title ?? '');
const rotation = ref('');

const showMoreToggle = ()=> {
  hidden.value = !hidden.value;
  const moreTitle = more?.value?.title ?? '';
  buttonText.value = buttonText.value === moreTitle ? 'Zeige weniger' : moreTitle;
  rotation.value = rotation.value === '' ? 'rotate-down' : '';
}
const toShow  = ref(0);
onMounted(() => {
  toShow.value = (window.innerWidth <= 1199) ? 3 : 5;
});
</script>

<template>
  <section class="section section-main section--solid section-products section-products--secondary"  :style="props.style" :class="props.class">
    <div class="container">
      <header class="section__head">
        <h2>{{ heading?.value }}</h2>
      </header><!-- /.section__head -->

      <div class="section__body">
        <ul class="features section__features">
          <template  v-for="(category, index) in (categories?.value ?? [])" :key="index">
            <transition name="fade" mode="out-in">
            <li v-show="index < toShow || !hidden" class="feature feature--primary features__feature" >
              <NuxtLink :to="getSanitizeUrl(category.link?.url)" :target="category.link?.target">
              <div class="feature__icon">
                <i class="ico-cake">
                  <NuxtImg format="webp" loading="lazy" :src="category.icon?.url" alt="" width="71" ></NuxtImg>
                </i>
              </div><!-- /.feature__icon -->
              </NuxtLink>
              <div class="feature__content">
                <h3>
                  <NuxtLink :to="getSanitizeUrl(category.link?.url)" :target="category.link?.target">
                    {{ category.link?.title }}
                  </NuxtLink>
                </h3>
              </div><!-- /.feature__content -->
            </li>
            </transition>
          </template>
        </ul>
      </div><!-- /.section__body -->

      <footer v-show="toShow > 0" class="section__foot text-center">
        <NuxtLink to="javascript:;" class="btn btn-default btn-danger btn-icon btn-icon--alt btn-medium section__btn" @click="showMoreToggle()">
          <span>{{ buttonText }}</span>
          <i class="ico-arrow-down" :class="rotation">
            <img src="assets/images/svg/arrow-down.svg" alt="" width="25" height="29">
          </i>
        </NuxtLink>
      </footer><!-- /.section__foot -->
    </div><!-- /.container -->
  </section>
</template>

<style scoped>
.hidden-elements {
  height: 0;
  overflow: hidden;
}

.ico-arrow-down {
  transition: transform 0.3s ease;
}

.rotate-down {
  transform: rotate(180deg); /* Rotate the arrow 360 degrees */
}

.fade-enter-active,
.fade-leave-active {
  transition: all 0.6s ease;
}
.fade-enter-from,
.fade-leave-to {
  transform: scale(0);
}
</style>